<template>
    <div class="footer">
      <div class="container">
        <img src="@/assets/image/publicSecurityIcon.png" alt="">
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32058302002921">公安部备案号：32058302002921</a> 
        <span>| 网站备案号：苏ICP备2021026395号-1 昆山丘钛微电子科技股份有限公司</span>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "Footer",
    data() {
      return {
        
      };
    },
    methods:{
        
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .footer{
    padding-bottom: 100px;
    font-size: 12px;
    @media (max-width: 1200px) {
        padding: 15px 30px;
    }
    a{
        display: inline-block;
        vertical-align: middle;
    }
    img{
        vertical-align: middle;
    }
    span{
        vertical-align: middle;
        display: inline-block;
    }
  }
  </style>
    


// WEBPACK FOOTER //
// src/components/Footer.vue